import { Dropdown, DropdownList, ToastMessage } from '@cokitchen/cokitchen-components';
import { NotificationIcon } from 'cokitchen-icons';
import React, { useEffect, useState } from 'react';
import { ReactComponent as FileIcon } from 'assets/icons/file-icon.svg';
import NotificationSideModal from './notification-side-modal';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { PANEL_ROLES } from 'utils/roles';
import { readStoredRole } from 'utils/authorization';
import { NotificationType } from 'models/production-report.model';
import { getSimpleDateFormat } from 'utils/functions';

const NotificationDropdown = () => {
  const [showNotificationDropdown, setShowNotificationDropdown] = useState(false);
  const [showNotificationSideModal, setShowNotificationSideModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [previewNotification, setPreviewNotification] = useState<NotificationType[]>([]);

  const toggleNotificationSideModal = () => {
    setShowNotificationSideModal(!showNotificationSideModal);
    setShowNotificationDropdown(false);
  };

  const today = new Date();
  const startDate = new Date(today.getFullYear(), today.getMonth(), 1);
  const endDate = today;
  const role = (readStoredRole()?.name ?? '') as PANEL_ROLES;

  const getNotifications = async () => {
    setLoading(true);
    try {
      const res = await apiService.get(`production-history/notification`, {
        params: {
          start_date: startDate,
          end_date: endDate,
          type: role,
          page: '1'
        }
      });
      res?.data?.data?.results ? setPreviewNotification(res?.data?.data?.results.splice(0, 4)) : '';
    } catch (err: any) {
      console.log(err?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getNotifications();
  }, [role]);

  const readNotifications = (notificationId: string) => {
    const data = {
      id: notificationId
    };
    const updatedNotificationData = previewNotification?.map((item) =>
      item.id === notificationId ? { ...item, is_read: true } : item
    );
    setPreviewNotification(updatedNotificationData);
    try {
      apiService.put('production-history/notification', { data });
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err?.response?.data?.message} />);
    }
  };
  return (
    <div>
      <Dropdown
        visible={showNotificationDropdown}
        onClickOutside={() => setShowNotificationDropdown(false)}
        content={
          <div
            onClick={() => setShowNotificationDropdown(true)}
            className='relative cursor-pointer'>
            <NotificationIcon className='w-12 h-12 p-[10px] rounded-full text-gray-10 bg-[#F2F2F3]' />
            <div className='w-3 h-3 absolute right-[11.5px] top-[8px] bg-red-5 rounded-full border-2 border-white' />
          </div>
        }>
        <DropdownList className='min-w-[350px] sm:w-[420px] md:min-w-[500px] max-h-[400px] p-6 space-y-4 overflow-y-hidden '>
          <div>
            <h3 className='text-xl sm:text-2xl font-bold mb-3'>Notifications</h3>
            <p className='text-[#96999C] text-xs'>Latest Updates</p>
          </div>

          <div className='space-y-4'>
            {loading ? (
              <div className='text-[#858585] text-sm my-4 text-center'>Loading ...</div>
            ) : previewNotification?.length === 0 ? (
              <div className=' text-sm text-center my-4'>No notifications available</div>
            ) : (
              previewNotification?.map((item) => (
                <div
                  key={item.id}
                  onClick={() => readNotifications(item.id)}
                  className='flex justify-between w-full items-center gap-3'>
                  <div className='flex gap-3'>
                    <div className='bg-[#F4F1F1] min-w-[28px] h-[26px] rounded-full flex justify-center items-center'>
                      <FileIcon />
                    </div>
                    <div className='flex flex-col gap-1'>
                      <p className='text-[#5E6164]'>{item.message}</p>
                      <p className='text-[#737373] text-[10px]'>
                        {getSimpleDateFormat(item.updated_at)}
                      </p>
                    </div>
                  </div>

                  <div
                    className={`min-w-[10px] h-[10px] ${
                      item.is_read ? 'bg-[#EDEDEE]' : 'bg-[#E60A2B]'
                    }  rounded-full `}></div>
                </div>
              ))
            )}
          </div>

          {previewNotification?.length > 0 && (
            <button
              onClick={toggleNotificationSideModal}
              className='w-full bg-[#F2F2F2] rounded-[100px] text-[#2E3031] h-[41px]'>
              View All
            </button>
          )}

          {showNotificationSideModal && (
            <NotificationSideModal
              show={showNotificationSideModal}
              onClose={toggleNotificationSideModal}
            />
          )}
        </DropdownList>
      </Dropdown>
    </div>
  );
};

export default NotificationDropdown;
